import routes from "./router/routes"

export function schedulingModule({ router }) {
  for (const route of routes) router.addRoute("dashboard", route)
}
